import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Slider from "react-slick"

import { urlToHost } from "../../utilities/FrontFunctions/AoxFrontFunctions"

import '../../assets/css/0020_objects/0940_obj_carousel_aside_banner.css'


class ObjAsideSliderBanner extends Component {
	constructor() {
		super()
		this.state = {
			pushBannerList: [
				{
					hasLinkBanner: false,
					linkBanner: "",
					visuelBanner: "/-/media/formationcaf/System/Formations/v_carousel_formation_02.ashx",
					altTextBanner: "Préparez-vous au mieux !"
				},
				{
					hasLinkBanner: false,
					linkBanner: "",
					visuelBanner: "/-/media/formationcaf/System/Formations/v_carousel_formation_03.ashx",
					altTextBanner: "Informez-nous de votre absence"
				},
				{
					hasLinkBanner: false,
					linkBanner: "",
					visuelBanner: "/-/media/formationcaf/System/Formations/v_carousel_formation_04.ashx",
					altTextBanner: "Ne manquez plus un evenement"
				}
			]
		}
	}

	onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}
	
	render() {
		const sliderRef = slider => {this.slider = slider}
		const settings = {
            className: "obj_carousel_aside_banner",
			infinite: true,
			autoplay: true,
			autoplaySpeed: 5000,
			slidesToShow: 1,
			swipeToSlide: true,
			onSwipe: this.onSwipe.bind(this),
			arrows: true,
			dots: true,
			dotsClass: "slider-nav",
			appendDots: dots => (
				<div className="slider-nav" >
					<ul> {dots} </ul>
				</div>
			),
			speed: 750,
        }


		return (
			<div className="obj_aside_carrousel_banner">
				<div className="ctn_carrousel">
					<Slider {...settings} ref={sliderRef}>
						{this.state.pushBannerList.map((itemSlider, index) => (
							<div key={index} className="item">
								{itemSlider.hasLinkBanner ? (
									<div className="obj_image_banner">
										<Link to={itemSlider.linkBanner}>
											<div className="obj_image">
												<picture className="ctn_image fade-in">
													<img src={urlToHost(itemSlider.visuelBanner)} alt={itemSlider.altText || ""} />
												</picture>
											</div>
										</Link>
									</div>
								) : (
									<div className="obj_image_banner">
										<div className="obj_image">
											<picture className="ctn_image fade-in">
												<img src={urlToHost(itemSlider.visuelBanner)} alt={itemSlider.altText || ""} />
											</picture>
										</div>
									</div>
								)}
							</div>
						))}
					</Slider>
				</div>
			</div>
		)
	}
}

export default ObjAsideSliderBanner